import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PhoneConfirmationUi } from './phone-confirmation.type';
import { postConfirmOtpCode, postEditLead } from './phone-confirmation.model';
import { postCreateUnverifiedLead } from '../get-started/get-started.model';

const initialState: PhoneConfirmationUi ={
    confirming:false,
    otpCode: undefined,
    isEditPhoneModalOpen: false,
    editingLead: false,
    phoneNumber:undefined,
    step: "otpConfirmation",
    resultMsg: ""
}
const phoneConfirmationSlice = createSlice({
    name:"phoneConfirmation",
    initialState,
    reducers:{
        setOtpCode: (state, action:PayloadAction<PhoneConfirmationUi["otpCode"]> )=>{
            state.otpCode= action.payload
        },
        setIsEditPhoneModalOpen: (state, action:PayloadAction<PhoneConfirmationUi["isEditPhoneModalOpen"]> )=>{
            state.isEditPhoneModalOpen= action.payload
        },
        resetPhoneConfirmationState:(state)=>{
            state.isEditPhoneModalOpen=false;
            state.phoneNumber=undefined;
            state.confirming=false;
            state.otpCode= undefined;
        },
        resetResultStep:(state)=>{
            state.isEditPhoneModalOpen=false;
            state.phoneNumber=undefined;
            state.confirming=false;
            state.otpCode= undefined;
            state.step = "otpConfirmation";
            state.resultMsg = "";
        },
    },
    extraReducers:(builder)=> {
        builder.addCase(postEditLead.pending, (state)=>{
            state.editingLead = true;
        });
        builder.addCase(postEditLead.fulfilled, (state,action)=>{
            state.editingLead = false;
            if(action.payload){
                state.isEditPhoneModalOpen= false;
                state.phoneNumber=action.payload;
            }
        });
        builder.addCase(postCreateUnverifiedLead.fulfilled, (state, action)=>{
            if(action.payload?.captain_mobile){
                state.phoneNumber= action.payload?.captain_mobile;
            }
            if(action.payload?.result?.navigate_to_end){
                state.step= "result";
                state.resultMsg= action.payload?.result?.message;
            }
        });
        builder.addCase( postConfirmOtpCode.pending,(state)=>{
            state.confirming = true;
        });
        builder.addCase(postConfirmOtpCode.fulfilled,(state, action)=>{
            state.confirming = false;
            if(action.payload?.message){
                state.step= "result";
                state.resultMsg= action.payload.message;
            }
        });
    },
});
export const {setOtpCode, setIsEditPhoneModalOpen, resetPhoneConfirmationState, resetResultStep} = phoneConfirmationSlice.actions;
export const phoneConfirmationReducer = phoneConfirmationSlice.reducer;
export default phoneConfirmationSlice;